import { render, staticRenderFns } from "./ListRangesEscalonamento.vue?vue&type=template&id=48c71c4a&"
import script from "./ListRangesEscalonamento.vue?vue&type=script&lang=js&"
export * from "./ListRangesEscalonamento.vue?vue&type=script&lang=js&"
import style0 from "./ListRangesEscalonamento.vue?vue&type=style&index=0&id=48c71c4a&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48c71c4a')) {
      api.createRecord('48c71c4a', component.options)
    } else {
      api.reload('48c71c4a', component.options)
    }
    module.hot.accept("./ListRangesEscalonamento.vue?vue&type=template&id=48c71c4a&", function () {
      api.rerender('48c71c4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ListRangesEscalonamento.vue"
export default component.exports